import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as DateFns from 'date-fns';

import { CURRENT, CUSTOM, FILTER_KEYS, HEALTH_WAIT_TIME_SLIDER } from '../../../../config/constants';
import { useInterval, useRouter } from '../../../../helpers/customHooks';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';


export const HealthTimeSlider = ({ forceScope }: { forceScope?: string }) => {

  const { specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const { [FILTER_KEYS.TIME_SLIDER]: timeSlider } = useFiltersState(specificScope, FILTER_KEYS.TIME_SLIDER);
  const { changeFilterData } = useFiltersDispatch();
  const changeItemsSelected = (itemsSelected: any) => changeFilterData(itemsSelected, FILTER_KEYS.TIME_SLIDER, forceScope)();
  const timerRef = useRef<null | ReturnType<typeof setTimeout>>(null);
  const calculateMinutes = () =>{
    const currentDate = new Date().getTime();
    const iniDate = new Date();
    iniDate.setHours(0,0,0,0);
    let hours = currentDate - iniDate.getTime();
   var hoursDifference = Math.floor(hours/1000/60/60);
      hours -= hoursDifference*1000*60*60;
   var minutesDifference = Math.floor(hours/1000/60);
      hours -= minutesDifference*1000*60;
      MINUTES_OF_RANGE = hoursDifference*60 + minutesDifference;
  };
  let MINUTES_OF_RANGE: number =0;
  calculateMinutes();
  useInterval(() => {
    calculateMinutes();
    if (timeSlider && timeSlider.status === CURRENT) {
      const currentDate = new Date().getTime();
      changeItemsSelected({
        status: CURRENT,
        selectedTime: currentDate,
        rangeTimeStart: currentDate,
        rangeTimeEnd: currentDate,
        interval: true
      });
    }
  }, (timeSlider && timeSlider.status === CURRENT) ? 60 * 1000 : null);
  const getValue = useCallback(() => (
    !timeSlider || timeSlider.status === CURRENT) ? 0 : ((timeSlider.selectedTime - new Date().getTime()) / 1000 / 60)
    , [timeSlider]);
  const [value, setValue] = useState<number>(getValue());
  useEffect(() => setValue(getValue()), [getValue]);

  const checkboxInputHandler = () => {
    if (timeSlider && timeSlider.status === CURRENT) {
      changeItemsSelected({
        ...timeSlider,
        status: CUSTOM,
        interval: false
      });
    } else {
      const currentDate = new Date().getTime();
      changeItemsSelected({
        status: CURRENT,
        selectedTime: currentDate,
        rangeTimeStart: currentDate,
        rangeTimeEnd: currentDate,
        interval: false
      });
    }
  };
  const rangeInputHandler = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setValue(+target.value);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      const currentDate = new Date();
      changeItemsSelected({
        status: CUSTOM,
        selectedTime: DateFns.subMinutes(currentDate, -target.value).getTime(),
        rangeTimeStart: DateFns.subMinutes(currentDate, MINUTES_OF_RANGE).getTime(),
        rangeTimeEnd: currentDate.getTime(),
        interval: false
      });
    }, HEALTH_WAIT_TIME_SLIDER);
  };
  return (
    <>
      <div className="keep-00">
        <label className="l-c">
          <input
            className="styled-checkbox"
            id="styled-checkbox-2"
            type="checkbox"
            checked={timeSlider && (timeSlider.status === CURRENT)}
            onChange={checkboxInputHandler}
          />
          <label htmlFor="styled-checkbox-2" className="check-l" />
        </label>
        <b>Keep Current</b>
      </div>
      <div className="health-time-slider">
        <input
          type="range"
          className="custom-range"
          id="customRange1"
          min={-MINUTES_OF_RANGE}
          max={0}
          onChange={rangeInputHandler}
          value={value}
        />
      </div>
    </>
  );
};
